// app/(app)/inventory/_layout.tsx
import { useAppTheme } from "@/hooks/useAppTheme";
import { useAppSelector } from "@/store/hooks";
import { Ionicons } from "@expo/vector-icons";
import { Tabs } from "expo-router";

export default function InventoryLayout() {
  const { colors } = useAppTheme();
  const { user } = useAppSelector((state) => state.auth);
  const isOwner = user?.userType === "Owner";

  return (
    <Tabs
      initialRouteName="stock"
      screenOptions={{
        headerStyle: { backgroundColor: colors.background },
        headerTintColor: colors.text,
        tabBarStyle: {
          backgroundColor: colors.background,
          borderTopColor: colors.border,
        },
        tabBarActiveTintColor: colors.primary,
        tabBarInactiveTintColor: colors.textLight,
        headerShown: false,
      }}
    >
      <Tabs.Screen
        name="products"
        options={{
          title: "Products",
          tabBarIcon: ({ color, size }) => (
            <Ionicons name="cube-outline" size={size} color={color} />
          ),
        }}
      />
      <Tabs.Screen
        name="stock"
        options={{
          title: "Stock Records",
          tabBarIcon: ({ color, size }) => (
            <Ionicons name="list-outline" size={size} color={color} />
          ),
        }}
      />
      <Tabs.Screen
        name="units"
        options={{
          title: "Units",
          tabBarIcon: ({ color, size }) => (
            <Ionicons name="scale-outline" size={size} color={color} />
          ),
          // Hide the tab completely for non‑owners
          href: isOwner ? undefined : null,
        }}
      />
    </Tabs>
  );
}
